export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";